export default {
  title: 'Bedankt voor het indienen van uw gegevens om betalingen te ontvangen',
  description:
    'De beoordeling door Stripe kan tot 48 uur duren. U kunt ondertussen doorgaan met de volgende stappen. Wij informeren u per e-mail zodra uw gegevens zijn bevestigd.',
};
